export const userModelData = function () {
  return {
    auth: false,
    success: null,
    userList: []
  }
}
